module.exports = __webpack_public_path__ + "static/galeb_duhr-91755daa97ce4f3ee05e31674dbc74e7.jpg";